import { render, staticRenderFns } from "./infinity-wrapper.vue?vue&type=template&id=17e5fbf4&scoped=true"
import script from "./infinity-wrapper.vue?vue&type=script&lang=js"
export * from "./infinity-wrapper.vue?vue&type=script&lang=js"
import style0 from "./infinity-wrapper.vue?vue&type=style&index=0&id=17e5fbf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e5fbf4",
  null
  
)

export default component.exports